export const COOKIE_HIDE_TRANSPARENCY_BANNER = 'hideTransparencyBannerTimestamp'
